{
  "static-content-download-app": {
    "buttons": {},
    "text": {
      "title": "Télécharger l'application Beauty Booking",
      "description": "Notre logiciel est conçu pour vous faciliter la vie. Alors pourquoi attendre ? Téléchargez notre application dès aujourd'hui et commencez à vivre une vie plus organisée et sans stress !"
    }
  }
}
